// extracted by mini-css-extract-plugin
export default {"oneButtonFooter":"modalFooter_oneButtonFooter__sU86m","twoButtonFooter":"modalFooter_twoButtonFooter__5qINT"};